<template>
  <div>
    <a
      class="btn btn-sm btn-success"
      data-target="#modalAddProductoPrecio"
      data-toggle="modal"
      href="#"
    >
      <i class="os-icon os-icon-ui-22"></i>
      <span>Buscar Cliente</span>
    </a>

    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddProductoPrecio"
      role="dialog"
      tabindex="-1"
    >
    <div class="modal-dialog modal-xl" role="document" style="max-width: 100%;">
        <div class="modal-content modal-xl" style="max-width: 100%;">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Cuentas de Clientes</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <ClientesSelectComponent :current="current" />
              </div>
              <div class="col-12">
                <CuentasTableComponent
                  @setDefault="setDefault"
                  :datos="current"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="current.cliente_nit"
              class="btn"
              @click="agregarCobro(current)"
              style="background-color: #ff8d33"
              onmouseover="this.style.color='black'"
              onmouseout="this.style.color='white'"
            >
              agregar un nuevo Cobro
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddCobro"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Cuentas de Clientes</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h6 class="modal-title text-danger">
              Complete la siguiente información
            </h6>
            <br />
            <div class="row">
              <div class="col-12">
                <ClientesSelectComponent :current="current" />
              </div>
              <div class="col-12">
                <TiendaSelectComponent
                  @change="refreshCaja(current)"
                  :current="current"
                />
              </div>
              <div v-if="current.tienda" class="col-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger': current.errors && current.errors.caja,
                    }"
                    >Caja</label
                  >
                  <select
                    class="form-control"
                    autofocus="autofocus"
                    v-model="current.caja"
                  >
                    <option v-for="(c, key) in caja" :value="c.id" :key="key">
                      Caja: {{ c.caja }} - Tienda {{ c.tienda.nombre }}
                    </option>
                  </select>
                  <small
                    v-if="current.errors && current.errors.caja"
                    class="form-text text-danger"
                    >{{ current.errors.caja }}</small
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="current.cliente_nit"
              class="btn"
              @click="guardar(current)"
              style="background-color: #ff8d33"
              onmouseover="this.style.color='black'"
              onmouseout="this.style.color='white'"
            >
              Guardar Información
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import Notifications from "@/notifications/notifications";
import ClientesSelectComponent from "@/components/commons/ClientesSelectComponent";
import CuentasTableComponent from "@/components/cxc/cobros/CuentasTableComponent";
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    ClientesSelectComponent,
    CuentasTableComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      _current: {},
      caja: "",
      current: {
        cliente_nit: "",
        cliente_nombre: "",
        cliente_direccion: "",
        tienda: null,
        caja: null,
        estado: "A",
        errors: [],
      },
    };
  },
  mounted() {},
  methods: {
    guardar(id) {
      let self = this;
      (self.params = {
        cliente_nit: self.current.cliente_nit.nit,
        cliente_nombre: self.current.cliente_nit.nombre,
        cliente_direccion: self.current.cliente_nit.direccion,
        email: self.current.cliente_nit.email,
        cliente: self.current.cliente_nit.nit,
        tienda: self.current.tienda,
        caja: self.current.caja,
      }),
        DynamicService.save("cxc", "cobros", self.params)
          .then((response) => {
            $("#modalAddCobro").modal("hide");
            this.$emit("refresh");
            Notifications.alert.success(
              "Agregar Nuevo Cobro",
              "Se ha realizado correctamente"
            );
            id = response.data.id;
            self.$router.push({
              name: "cxc-cobros-editar",
              params: { id },
            });
          })
          .catch((error) => {
            self.current.errors = error.response.data;
            Notifications.alert.error(
              "error",
              self.current.errors.detail
            )
          });
    },
    refreshCaja(current) {
      let self = this;
      DynamicService.fetch("cxc", "caja", {
        tienda: current.tienda,
      }).then((response) => {
        self.caja = response.data.results;
      });
    },
    agregarCobro(current) {
      let self = this;
      $("#modalAddProductoPrecio").modal("hide");
      $("#modalAddCobro").modal();
    },
    setDefault() {
      let self = this;
      self.current.cliente_nit = "";
    },
    cerrandoModal() {
      this.$emit("cerrandomodal");
    },
    refreshCajas() {
      let self = this;
      CajaService.fetch({
        tienda: self.current.tienda,
        quitar_paginacion: true,
      }).then((res) => {
        self.cajas = res.data;
      });
    },
  },
};
</script>
